import type { FC } from 'react';

import { useDashboardPage } from '@/features/dashboard/hooks/useDashboardPage.hook';

const DashboardPage: FC = () => {
  const { user, isLoading } = useDashboardPage();

  return (
    <div className="flex flex-col gap-6">
      <header>
        <h1 className="text-2xl font-extrabold tracking-tight text-[var(--color-ink)]">Dashboard</h1>
        <p className="text-sm text-[var(--color-ink-muted)]">
          {isLoading ? 'Loading…' : user ? `Signed in as ${user.name}` : ''}
        </p>
      </header>

      <section className="rounded-2xl border border-[var(--color-divider)] bg-white p-6">
        <h2 className="text-base font-semibold text-[var(--color-ink)]">Welcome to Shoutt admin</h2>
        <p className="mt-2 text-sm text-[var(--color-ink-muted)]">
          This is a placeholder. Real admin features will replace this card.
        </p>
      </section>
    </div>
  );
};

export default DashboardPage;
